export default "__VITE_ASSET__2cd69442__"